import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';

export function ToolFAQ({ items }) {
    return (
        <section className="mt-14">
            <h2 className="text-xl md:text-2xl font-semibold tracking-tight text-slate-900">
                Frequently asked questions
            </h2>
            <Accordion type="single" collapsible className="mt-4">
                {items.map((it, i) => (
                    <AccordionItem key={i} value={`item-${i}`} className="border-border/70">
                        <AccordionTrigger className="text-left text-sm md:text-base font-medium text-slate-900">
                            {it.q}
                        </AccordionTrigger>
                        <AccordionContent className="text-sm text-slate-600 leading-relaxed">
                            {it.a}
                        </AccordionContent>
                    </AccordionItem>
                ))}
            </Accordion>
        </section>
    );
}
